import { usePatientProfile } from 'apps/wrapper/src/hooks/use-patient-profile';
import { FC, useMemo } from 'react';
import { AllCommunicationSection, CommunicationSubSection, Section, SelectAllSection, Separator } from './comm-preferences.styles';


type CommPreferencesEmailViewProps = {
  setChange: (key: string, value: any) => void;
  changes: any;
};

export const CommPreferencesEmailView: FC<CommPreferencesEmailViewProps> = ({ setChange, changes }) => {
  const { patientPreferences } = usePatientProfile();

  const localPreferences = useMemo(
    () => changes.updateLocalPreferences || patientPreferences,
    [patientPreferences, changes]
  );

  const updateLocalPreferences = (state: Partial<typeof patientPreferences>) => {
    const newState = { ...patientPreferences, ...changes.updateLocalPreferences, ...state };

    setChange('updateLocalPreferences', newState);
  };

  return (
    <div>
      <Section>
        <SelectAllSection>
          <AllCommunicationSection
            text="All Email"
            isChecked={
              localPreferences.emailAppointmentReminders &&
              localPreferences.emailBirthdayAndHolidayCards &&
              localPreferences.emailExpiringInsuranceReminder &&
              localPreferences.emailPatientReactivation &&
              localPreferences.emailPostOpInstructions &&
              localPreferences.emailRecalls &&
              localPreferences.emailReviewsAndSurveys &&
              localPreferences.emailSpecialsAndNewsletters &&
              localPreferences.emailTreatmentPlanFollowUps
            }
            onChange={(value) =>
              updateLocalPreferences({
                emailAppointmentReminders: value,
                emailBirthdayAndHolidayCards: value,
                emailExpiringInsuranceReminder: value,
                emailPatientReactivation: value,
                emailPostOpInstructions: value,
                emailRecalls: value,
                emailReviewsAndSurveys: value,
                emailSpecialsAndNewsletters: value,
                emailTreatmentPlanFollowUps: value
              })
            }
          />
        </SelectAllSection>
        <Separator>Essential Communications</Separator>
        <CommunicationSubSection
          text="Appointment Reminders"
          isChecked={localPreferences.emailAppointmentReminders}
          onChange={(value) => updateLocalPreferences({ emailAppointmentReminders: value })}
        />
        <CommunicationSubSection
          text="Post-Op Instructions"
          isChecked={localPreferences.emailPostOpInstructions}
          onChange={(value) => updateLocalPreferences({ emailPostOpInstructions: value })}
        />
        <CommunicationSubSection
          text="Recalls"
          isChecked={localPreferences.emailRecalls}
          onChange={(value) => updateLocalPreferences({ emailRecalls: value })}
        />
        <CommunicationSubSection
          text="Patient Reactivation"
          isChecked={localPreferences.emailPatientReactivation}
          onChange={(value) => updateLocalPreferences({ emailPatientReactivation: value })}
        />
        <Separator>Marketing & Promotional</Separator>
        <CommunicationSubSection
          text="Treatment Plan Follow-ups"
          isChecked={localPreferences.emailTreatmentPlanFollowUps}
          onChange={(value) => updateLocalPreferences({ emailTreatmentPlanFollowUps: value })}
        />
        <CommunicationSubSection
          text="Reviews & Surveys"
          isChecked={localPreferences.emailReviewsAndSurveys}
          onChange={(value) => updateLocalPreferences({ emailReviewsAndSurveys: value })}
        />
        <CommunicationSubSection
          text="Birthday/Holiday Cards"
          isChecked={localPreferences.emailBirthdayAndHolidayCards}
          onChange={(value) => updateLocalPreferences({ emailBirthdayAndHolidayCards: value })}
        />
        <CommunicationSubSection
          text="Email Specials & Newsletters"
          isChecked={localPreferences.emailSpecialsAndNewsletters}
          onChange={(value) => updateLocalPreferences({ emailSpecialsAndNewsletters: value })}
        />
        <CommunicationSubSection
          text="Expiring Insurance Reminder"
          isChecked={localPreferences.emailExpiringInsuranceReminder}
          onChange={(value) => updateLocalPreferences({ emailExpiringInsuranceReminder: value })}
        />
      </Section>
    </div>
  );
};
